var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout w-100"},[_c('header',[_vm._t("header")],2),_c('div',{staticClass:"subheader"},[_vm._t("subheader")],2),_c('main',[_vm._t("default")],2),(_vm.navigation)?_c('cms-navigation'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }